export const fvformat =  function (s:string, ...args) {
    // var args = arguments;
    return s.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] != 'undefined' ? args[number] : match;
    });
  };